<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css" media="print" onload="this.media='all'">
<ion-app>
  <app-header [isNativeApp]="isNativeApp"></app-header>
  
  <ion-content> 
    <ion-router-outlet></ion-router-outlet>
  </ion-content>

  <ion-footer *ngIf="isNativeApp" class="ion-no-border mobile-tab-bar">
    <ion-tab-bar slot="bottom">
      
      <ion-tab-button routerLink="/" routerLinkActive="selected-tab" [routerLinkActiveOptions]="{ exact: true }">
        <ion-icon name="home-outline"></ion-icon>
        <ion-label>{{ 'HOME' | translate }}</ion-label>
      </ion-tab-button>

      <ion-tab-button (click)="showOpportunitiesMenu()" [class.selected-tab]="isActive('/opportunity')">
        <ion-icon name="search-outline"></ion-icon>
        <ion-label>{{ 'OPPORTUNITIES' | translate }}</ion-label>
      </ion-tab-button>

      <ion-tab-button routerLink="/expert-database" routerLinkActive="selected-tab">
        <ion-icon name="people-outline"></ion-icon>
        <ion-label>Experts</ion-label>
      </ion-tab-button>

      <ion-tab-button *ngIf="isAdmin$ | async" (click)="showAdminMenu()" [class.selected-tab]="isActive('/admin')">
        <ion-icon name="settings-outline"></ion-icon>
        <ion-label>{{ 'ADMIN' | translate }}</ion-label>
      </ion-tab-button>

      <ion-tab-button routerLink="/about" routerLinkActive="selected-tab">
        <ion-icon name="information-circle-outline"></ion-icon>
        <ion-label>{{ 'ABOUT' | translate }}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-footer>
</ion-app>